// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_eZ","advertDetailContacts__header":"c-n_fa"};